import Reflux from 'reflux';

export default Reflux.createActions({
  updateField: {},
  updateColumn: {},
  submit: { sync: true },
  clear: {},
});
